module.exports = __webpack_public_path__ + "img/128.7ec111f4.svg";